import { getAmplitudeInstance } from '../amplitudeHelpers';
import ProductType from '../enums/ProductType';
import TrailPageType from '../enums/TrailPageType';

type logTrailDetailsBackpackingBannerTappedParams = {
  member_tier?: ProductType;
  trail_id: number;
  trail_page_type?: TrailPageType;
};

/**
 * User taps the backpacking Route Assistant banner on an eligible trail details page. Free/Plus users proceed to a Peak upsell; Peak users open the custom route builder with the trail loaded.
 * @param params - Attributes to log with the amplitude event
 * @param params.member_tier - The current subscription level of the user who tapped the banner (free, plus, or peak).
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.trail_page_type - Type of trail page where the backpacking banner was tapped.
 */
const logTrailDetailsBackpackingBannerTapped = (
  { member_tier, trail_id, trail_page_type }: logTrailDetailsBackpackingBannerTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details backpacking banner tapped',
    { 'member tier': member_tier, 'trail id': trail_id, 'trail page type': trail_page_type },
    callback
  );
};

export default logTrailDetailsBackpackingBannerTapped;
